'use client';
import { Badge } from '~/components/ui';
import { useSubscriptionStatus } from '~/hooks/useSubscriptionStatus';
import { BadgeProps } from '../ui/Badge';

/** All known subscription plan keys as defined in the backend SubscriptionController. */
export type PlanKey =
    | 'clubmembermanagementtool'
    | 'spacebookingtool'
    | 'eventtool'
    | 'attendancelisttool'
    | 'invoicetool';

/** Display labels for each plan key, sourced from Nova/SubscriptionOverride.php. */
const PLAN_LABELS: Record<PlanKey, string> = {
    clubmembermanagementtool: 'Mitgliederverwaltung',
    spacebookingtool: 'Platzbuchung',
    eventtool: 'Events',
    attendancelisttool: 'Trainingsjournal',
    invoicetool: 'Rechnungen'
};

interface CheckSubscriptionBadgeProps extends BadgeProps {
    /** Subscription plan key used for the lookup and label resolution. */
    planKey: PlanKey;
    /** When true, renders nothing while the plan is active */
    hideWhenActive?: boolean;
}

/** Renders a flat success or error badge indicating subscription status for the given plan. */
export function CheckSubscriptionBadge({ planKey, hideWhenActive = false, ...props }: CheckSubscriptionBadgeProps) {
    const { hasAccess, isLoading } = useSubscriptionStatus({ permission: planKey });
    const planName = PLAN_LABELS[planKey];

    if (isLoading) return null;
    if (hasAccess && hideWhenActive) return null;
    if (hasAccess)
        return (
            <Badge flat color="success" size="sm" {...props}>
                mit {planName}
            </Badge>
        );

    return (
        <Badge flat color="error" size="sm" {...props}>
            Kein Abo für {planName}
        </Badge>
    );
}
